import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { moduleMaster } from 'src/app/Models/BasicForms/moduleMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-module-drawer',
  templateUrl: './module-drawer.component.html',
  styleUrls: ['./module-drawer.component.css'],
  providers: [DatePipe]
})

export class ModuleDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: moduleMaster;
  @Input() ShowLinkOrNot: boolean;
  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.loadAllProjects();
  }

  projectList = [];
  loadAllProjects() {
    this._apiService.getAllProjects(0, 0, 'ID', 'desc', ' and IS_ACTIVE=1').subscribe(projectData => {
      this.projectList = projectData['data'];

    }, err => {

    });
  }

  close(projectMasterPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(projectMasterPage);
  }

  resetDrawer(clientMasterPage: NgForm) {
    this.data = new moduleMaster();
    this.isSpinning = false;
    clientMasterPage.form.reset();
    this.ShowLinkOrNot = null;
  }

  isSpinning = false;
  logtext: string = "";

  save(addNew: boolean): void {
    var isOk = true;

    if (this.data.PROJECT_ID == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Valid Project", "");
    }

    if (this.data.NAME != undefined) {
      if (this.data.NAME.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Module Name", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Module Name", "");
    }

    if (this.data.STATUS != undefined) {
      if (this.data.STATUS.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Status", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Status", "");
    }

    // if(this.data.DESCRIPTION != undefined) {
    //   if(this.data.DESCRIPTION.trim()== '') {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Valid Module Description","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Valid Module Description","");
    // }

    // if(this.data.START_DATE != undefined) {
    //   if(this.data.START_DATE== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select Start Date","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select Start Date","");
    // }

    // if(this.data.END_DATE != undefined) {
    //   if(this.data.END_DATE== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select End Date","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select End Date","");
    // }

    // if(this.data.ESTIMATED_MANDAYS != undefined) {
    //   if(this.data.ESTIMATED_MANDAYS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Mandays","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Mandays","");
    // }

    // if(this.data.ESTIMATED_HOURS != undefined) {
    //   if(this.data.ESTIMATED_HOURS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Hour(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Hour(s)","");
    // }

    // if(this.data.ESTIMATED_MINUTES != undefined) {
    //   if(this.data.ESTIMATED_MINUTES== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Minute(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Minute(s)","");
    // }

    // if(this.data.ESTIMATED_SECONDS != undefined) {
    //   if(this.data.ESTIMATED_SECONDS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Second(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Second(s)","");
    // }

    if (isOk) {
      this.isSpinning = true;

      if (this.data.START_DATE != null) {
        this.data.START_DATE = this.datePipe.transform(this.data.START_DATE, "yyyy-MM-dd");
      } else {
        this.data.START_DATE = null;
      }

      if (this.data.END_DATE != null) {
        this.data.END_DATE = this.datePipe.transform(this.data.END_DATE, "yyyy-MM-dd");
      } else {
        this.data.END_DATE = null;
      }

      this.data.ESTIMATED_HOURS = 0;
      this.data.ESTIMATED_MINUTES = 0;
      this.data.ESTIMATED_SECONDS = 0;

      if (!this.data.ID) {
        this._apiService.createModule(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Module Added Successfully", "");

            if (!addNew) {
              this.drawerClose();
              this.isSpinning = false;

              this.logtext = 'Save & Close - Module Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Module Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.data = new moduleMaster();

              this.logtext = 'Save & New - Module Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Module Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Module", "");
            this.logtext = 'Save & Close - Module Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Module Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this._apiService.updateModule(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Module Updated Successfully", "");
            this.logtext = 'Update & Close - Module Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Module Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Module", "");
            this.logtext = 'Update & Close - Module Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Module Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open();
    }
  }
}
